<template>
    <v-form @submit.prevent="saveAttachment" ref="form">
        <v-card class="elevation-1 rounded-4">
            <v-toolbar flat height="45px">
                <span class="font-weight-bold">Update Attachment</span>
                <v-spacer></v-spacer>
                 <v-btn icon @click.native="closeDialog" :disabled="disabled">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-progress-linear v-if="loading_uploading" indeterminate height="2" class="mt-0"></v-progress-linear>

            <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                Error encountered. Please contact support. {{errorMessage}}
            </v-alert>  

            <v-card-text>
                
                <!-- upload section -->
                <v-layout row wrap>
                    <v-flex v-if="!uploadFileName" xs12 sm12 class="form-content">
                        <div class="text-xs-center">
                            <vue-dropzone ref="myVueDropzone" 
                                class="form-upload"
                                id="dropzone" 
                                :options="dropzoneOptions"
                                v-on:vdropzone-success="uploadSuccess"
                                v-on:vdropzone-file-added="fileAdded"
                                ></vue-dropzone>
                        </div>
                    </v-flex> 
                    <v-flex v-else xs12 sm12 class="form-content uploaded text-xs-left">
                        <span class="grey--text">Uploaded file: </span>
                        <span class="wrapped-filename">
                            {{ uploadFileName }}
                        </span>
                        <div v-if="hasDeleteRights" class="delete-container">
                            <v-btn icon small @click="showDeleteFile" :disabled="disabled" title="Delete uploaded file">
                                <v-icon small>delete</v-icon>
                            </v-btn>
                        </div>
                    </v-flex>
                </v-layout>

            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions class="mr-25">
                <v-spacer></v-spacer>
                <v-btn type="submit" class="primary" :disabled="disabled||loading||!this.uploadFileName" :loading="loading">Save</v-btn>
            </v-card-actions>
        </v-card>

        <v-dialog v-model="dialogOkCancel" persistent width="600">
            <ok-cancel :msg="dialogOkCancelMsg" :dialogOkCancel.sync="dialogOkCancel" @ok="onOkCancel"></ok-cancel>
        </v-dialog>
    </v-form>
</template>
<script>
    
import edocumentsApi from '@/api/edocuments'
import axios from 'axios'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import pageKeys from '@/common/pagekeys'
import awsS3Helper from '@/helpers/aws-s3'
import { hasDeleteRights } from '@/helpers/access-permissions'

export default {
    name: 'UpdateAttachment',
    components: {
        vueDropzone: vue2Dropzone,
        'ok-cancel': ()=> import("@/components/BasicPopups/OkCancel"),
    },
    data () {
        return {
            error: false,
            errorMessage: '',
            disabled: false,
            loading: false,
            loading_uploading: false,

            documentVersionId: null,
            uploadFileName: null,
            uploadFileType: null,

            //okcancel
            dialogOkCancel: false, 
            dialogOkCancelMsg: '',
            okCancelFunction: null,
        }
    },
    methods: {
        async saveAttachment() {
            try {
                this.loading = true
                this.disabled = true

                if (this.$refs.form.validate() && this.uploadFileName) {
                    const data = {
                        documentVersionId: this.documentVersionId,
                        fileName: this.uploadFileName,
                        fileType: this.uploadFileType
                    }

                    const response = await edocumentsApi.updateAttachment(data)
                  
                    if (response && response.status == 200) {
                        this.$emit('send', response.data)
                        this.$emit('update:dialogUpdateAttachment', false)
                    }
                }
                this.loading = false
                this.disabled = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        fileAdded() {
            // this.loading_uploading = true
        },
        uploadSuccess(file, response) {
            this.$refs.myVueDropzone.removeAllFiles(true)
            this.uploadFileName = response.fileName
            this.uploadFileType = response.fileType
            this.loading_uploading = false
        },
        async deleteFile() {
            try {
                //this deletes only the uploaded file
                const data = {
                    fileName: this.uploadFileName
                }
                const response = await edocumentsApi.deleteFile(data)
                if (response && response.status == 200) {
                    this.uploadFileName = null
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        setAdd(documentVersionId) {
            this.clearForm()
            this.mode = 'Add'
            this.documentVersionId = documentVersionId
        },
        onOkCancel() {
            if (typeof this.okCancelFunction === 'function') {
                this.okCancelFunction()
            }
            this.okCancelFunction = null
            this.dialogOkCancel = false
        },
        async closeDialog() {
            if (this.uploadFileName) {
                this.dialogOkCancelMsg = 'You have uploaded a file, but have not saved its details.<br>Closing this window will delete the uploaded file.<br>Do you want to proceed?'
                this.dialogOkCancel = true
                this.okCancelFunction = () => this.deleteUploadAndClosePopup() //no need to check hasDeleteRights here since no record has been saved yet
            }else{
                this.$emit('update:dialogUpdateAttachment', false)
            }
        },
        clearForm() {
            this.$refs.form.reset()
            this.fileUploadId = null
            this.uploadFileName = null
            this.uploadFileType = null
            this.error = false
            this.errorMessage = ''
            this.loading = false
        },
        async deleteUploadAndClosePopup() {
            await this.deleteFile()
            this.$emit('update:dialogUpdateAttachment', false)
        },
        showDeleteFile() {
            this.dialogOkCancelMsg = 'This action will delete the uploaded file.<br> Do you want to proceed?'
            this.dialogOkCancel = true
            this.okCancelFunction = () => {
                if (this.mode == 'Add') {
                    this.deleteFile()
                }else{
                    //do not delete the file in AWS directly so that when user cancels edit
                    //the file still exist
                    this.uploadFileName = null
                }
            }
        },
    },
    computed: {
        hasDeleteRights() {
            return hasDeleteRights(this.$router.currentRoute.path)
        },
        dropzoneOptions() {
            return {                    
                url: `${axios.defaults.baseURL}EDocument/upload`,    
                headers: { 
                    "Authorization": `Bearer ${localStorage.token}`,
                    "page_key": pageKeys.edocuments,
                    "session_id": localStorage.sessionId,
                    "source": "Customer"
                },
                addRemoveLinks: false,
                dictDefaultMessage: `<u>
                                        ${this.isMobile ? 'Tap to browse' : 'Drag and drop your file or click to browse'}
                                    </u>
                                    <p class='caption mt-5'>
                                        Maximum 10MB per file.<br>
                                        Accepted file types: Images (.jpg, .jpeg, .png) and PDFs (.pdf)
                                    </p>`,
                maxFiles: 1,
                acceptedFiles: [
                    'image/jpeg',
                    'image/jpg',
                    'image/png',
                    'application/pdf'
                    ].join(','),
                maxFilesize: 10,   // 10MB
                init: function() {
                   this.on("error", function(file, message) {
                       const errorEl = file.previewElement.querySelector('.dz-error-message');
                       if (errorEl) {
                           errorEl.addEventListener('click', () => {
                               this.removeFile(file);
                           });
                       }
                   });
                }
            }
        },
    }
}
</script>
<style scoped>
.form-content {
    padding:0px 20px 0px 20px;
    margin-top:-5x;
}
.form-upload {
    height:150px;
    margin:15px 0px 10px 0px;
    padding:0px 50px 0px 50px;
    border: 1px dashed darkgray
}
.delete-container {
    float:right;
    margin-top:-10px;
}
.uploaded {
    margin-top: 15px;
}

/* ==========================================================================
   DROPZONE VUE-DEEP STYLING OVERRIDES (LIGHT BACKGROUND MINIMALIST LOOK)
   ========================================================================== */
::v-deep #dropzone {
    /* Changed to a dark translucent border for high contrast against light backdrops */
    border: 2px dashed rgba(0, 0, 0, 0.2) !important;
    border-radius: 8px;
    /* Soft light grey background */
    background-color: rgba(0, 0, 0, 0.03) !important;
    /* Dark charcoal text for optimal readability */
    color: #2c3e50 !important;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin: 10px;
}
::v-deep #dropzone .dz-preview {
    /* Crisp white preview box to stand out over the light grey dropzone */
    background: #ffffff !important; 
    /* Subtle light grey border */
    border: 1px solid rgba(0, 0, 0, 0.1) !important;
    border-radius: 8px !important;
    padding: 20px !important;
    width: 280px !important; 
    position: absolute !important;
    left: 50% !important;
    top: 50% !important;
    transform: translate(-50%, -50%) !important;
    margin: 0 !important;
    box-sizing: border-box !important;
    /* Softer, more expanded shadow for light UI designs */
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.08) !important;
}
::v-deep #dropzone .dz-preview .dz-image {
    border-radius: 6px !important;
    margin: 0 auto 15px auto !important;
    display: block !important;
    width: 120px !important;
    height: 120px !important;
}
::v-deep #dropzone .dz-preview.dz-error .dz-image {
    display: none !important;
}
::v-deep #dropzone .dz-preview .dz-details {
    /* Text color for file names and details changed to dark grey */
    color: #333333 !important;
    background: transparent !important;
    opacity: 1 !important;
    position: static !important;
    padding: 0 !important;
    text-align: center !important;
    margin-bottom: 12px !important;
}
::v-deep #dropzone .dz-preview .dz-error-message {
    display: none !important; 
}
::v-deep #dropzone .dz-preview.dz-error .dz-error-message {
    position: static !important; 
    opacity: 1 !important;
    display: block !important;
    /* Keeps a vibrant error red that pops cleanly on white backgrounds */
    background: #FF5252 !important;
    color: white !important;
    border-radius: 4px !important;
    padding: 12px 16px !important;
    font-size: 13px !important;
    font-weight: bold !important;
    text-align: center !important;
    margin: 5px 0 0 0 !important;
    width: 100% !important;
    box-sizing: border-box !important;
    cursor: pointer !important;
    transition: background-color 0.2s ease;
}
::v-deep #dropzone .dz-preview.dz-error .dz-error-message:hover {
    background-color: #D32F2F !important;
}
::v-deep #dropzone .dz-preview .dz-error-message:after {
    display: none !important;
}
::v-deep #dropzone .dz-preview .dz-success-mark,
::v-deep #dropzone .dz-preview .dz-error-mark,
::v-deep #dropzone .dz-preview .dz-remove {
    display: none !important;
}

</style>